import { ga } from 'js/analytics/adapters'
export const trackFinishedPlanTest = () => {
  ga.track('finished_the_test', {
    eventCategory: 'Plan test',
  })
}
